import Vue from "vue";
import VueLazyload from 'vue-lazyload'
import wrapper from "./webapp/axiosCache";
import axios from "axios";
import {vueAxiosPlugin} from "./vueAxiosPlugin";
import * as StrengthLevel from './coreExports';

const axiosCached = wrapper(axios, window.prefill);
Vue.use(vueAxiosPlugin, axiosCached);

axios.defaults.baseURL = window.apiUrl;

Vue.use(VueLazyload);

window.slrun = function () {
    StrengthLevel[arguments[0]].apply(null, [...arguments].slice(1));
};

window.slqueue.forEach(x => window.slrun.apply(null, x));